// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root__Background_2l763 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  z-index: -1;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "root__Background_2l763"
};
module.exports = exports;
